import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';

interface WidgetProperties extends commonTypes.WidgetInstanceProps {
    id?: string;
    dataContext: any;
    widgetInstance: any;
}

const CHILDREN_PLACEHOLDER_ID = 'children';

export default function PlaceholderConatiner(props: WidgetProperties) {
    const { dataContext, widgetInstance } = props;
    const { Placeholder } = commonHooks.useAppContext();
    return (
        <div className="placeholder-container">
            <Placeholder
                contentPlaceHolderId={`${CHILDREN_PLACEHOLDER_ID}`}
                parentWidgetInstanceId={widgetInstance?.id}
                data={dataContext}
            />
        </div>
    );
}
